module.exports = __webpack_public_path__ + "img/logo.7420cf7f.jpeg";